if (!customElements.get('atelier-countdown')) {
  const pageDeadlines = new Map();
  customElements.define('atelier-countdown', class extends HTMLElement {
    connectedCallback() {
      this.dailyTimer = this.dataset.mode === 'daily';
      if (this.dailyTimer) {
        try {
          this.dailyClock = new Intl.DateTimeFormat('en-GB', { timeZone: this.dataset.timezone || 'Europe/Bucharest', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        } catch (_) {
          this.dailyClock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
        }
      }
      this.visitorTimer = this.dataset.mode === 'duration';
      if (this.visitorTimer) {
        const duration = Number(this.dataset.minutes) * 60000;
        if (!Number.isFinite(duration) || duration <= 0) return;
        const key = `atelier-countdown:${this.dataset.key}:${duration}`;
        this.storageKey = key;
        this.duration = duration;
        if (!pageDeadlines.has(key)) {
          let saved = 0;
          try { saved = Number(localStorage.getItem(key)); } catch (_) {}
          const deadline = saved > Date.now() ? saved : Date.now() + duration;
          pageDeadlines.set(key, deadline);
          try { localStorage.setItem(key, String(deadline)); } catch (_) {}
        }
        this.end = pageDeadlines.get(key);
      } else if (this.dailyTimer) {
        this.end = Date.now() + 86400000;
      } else {
        this.end = Date.parse(this.dataset.end);
      }
      if (!Number.isFinite(this.end)) return;
      this.output = this.querySelector('time');
      const units = this.output.querySelectorAll('[data-timer-unit]');
      const renderTime = seconds => {
        const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0'));
        if (units.length) units.forEach((unit, index) => { unit.textContent = values[index]; });
        else this.output.textContent = (seconds >= 3600 ? values : values.slice(1)).join(':');
      };
      this.update = () => {
        clearTimeout(this.timer);
        if (this.visitorTimer && this.dataset.repeat === 'true' && this.end <= Date.now()) {
          this.end += (Math.floor((Date.now() - this.end) / this.duration) + 1) * this.duration;
          pageDeadlines.set(this.storageKey, this.end);
          try { localStorage.setItem(this.storageKey, String(this.end)); } catch (_) {}
        }
        let seconds = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        if (this.dailyTimer) {
          const parts = Object.fromEntries(this.dailyClock.formatToParts(new Date()).map(part => [part.type, part.value]));
          seconds = 86400 - ((Number(parts.hour) % 24) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
        }
        if (!seconds) {
          this.output.dateTime = 'PT0S';
          if (this.visitorTimer) {
            this.hidden = false;
            renderTime(0);
            return;
          }
          if (this.dataset.hideBar === 'true') this.closest('.atelier-promotion-bar').hidden = true;
          this.hidden = !this.dataset.expired;
          this.querySelector('span').hidden = true;
          this.output.textContent = this.dataset.expired || '';
          return;
        }
        renderTime(seconds);
        this.output.dateTime = `PT${seconds}S`;
        this.hidden = false;
        if (!document.hidden) this.timer = setTimeout(this.update, 1000);
      };
      this.abort = new AbortController();
      document.addEventListener('visibilitychange', this.update, { signal: this.abort.signal });
      this.update();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }
  });
}
